export enum UserRole {
    ADMIN = 'admin',
    FREE = 'free',
}
